module.exports = __webpack_public_path__ + "static/img/san.a83025c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/san.png
// module id = 02un
// module chunks = 1